import { useReducer } from "react";
import sessionActions from "./sessionActions";
import sessionReducer from "./sessionReducer";


export default function useSession() {
  const [session, sessionDispatch] = useReducer(sessionReducer, { session: null });
  const { fetch, 
    setSubscribed, 
    setSignalRConnected, 
    disconnect, 
    setSessionHelper } = sessionActions(sessionDispatch);

  return {
    response: session,
    fetch,
    setSubscribed,
    setSignalRConnected,
    disconnect,
    setSessionHelper
  };
}
